import * as React from 'react';

const query = '(pointer: coarse)';

const hasMatchMedia = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

// Module-level so the reference is stable and React does not resubscribe on every render.
const subscribe = (onChange: () => void): (() => void) => {
	if (!hasMatchMedia()) {
		return () => undefined;
	}

	const mediaQueryList = window.matchMedia(query);
	mediaQueryList.addEventListener('change', onChange);

	return () => {
		mediaQueryList.removeEventListener('change', onChange);
	};
};

const getSnapshot = (): boolean => (hasMatchMedia() ? window.matchMedia(query).matches : false);

const getServerSnapshot = (): boolean => false;

/** True when the primary pointer is touch. Falls back to `false` where `matchMedia` is unavailable. */
const useHasCoarsePointer = (): boolean =>
	React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useHasCoarsePointer;
